import React, { useEffect, useState } from 'react'
import { postAPI } from '../../app/api';
import { store, setStore } from '../../app/store';
import UnderMaintenanceImg from "../../theme/assets/img/illustrations/page-misc-under-maintenance.png";

export default function UnderMaintenance() {
  return (
    <div class="container-xxl container-p-y text-center">
      <div class="misc-wrapper">
        <h2 class="mb-1 mx-2">Under Maintenance!</h2>
        <p class="mb-4 mx-2">Sorry for the inconvenience but we're performing some maintenance at the moment</p>
        <a href="index.html" class="btn btn-primary mb-4 waves-effect waves-light">Back to home</a>
        <div class="mt-4">
          <img src={UnderMaintenanceImg} alt="page-misc-under-maintenance" width="550" class="img-fluid" />
        </div>
      </div>
    </div>
  )
}
